/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ServiceStatusFromJSON, ServiceStatusToJSON, } from './';
export function ServiceActionListDtoFromJSON(json) {
    return ServiceActionListDtoFromJSONTyped(json, false);
}
export function ServiceActionListDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'carName': !exists(json, 'carName') ? undefined : json['carName'],
        'carPlate': !exists(json, 'carPlate') ? undefined : json['carPlate'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'startDateTime': !exists(json, 'startDateTime') ? undefined : (new Date(json['startDateTime'])),
        'endDateTime': !exists(json, 'endDateTime') ? undefined : (new Date(json['endDateTime'])),
        'required': !exists(json, 'required') ? undefined : json['required'],
        'status': !exists(json, 'status') ? undefined : ServiceStatusFromJSON(json['status']),
    };
}
export function ServiceActionListDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'carName': value.carName,
        'carPlate': value.carPlate,
        'name': value.name,
        'startDateTime': value.startDateTime === undefined ? undefined : (value.startDateTime.toISOString()),
        'endDateTime': value.endDateTime === undefined ? undefined : (value.endDateTime.toISOString()),
        'required': value.required,
        'status': ServiceStatusToJSON(value.status),
    };
}
